'use strict';

import {module} from '../app';

module.service('FollowUpsDomain', [
    'authService', 'magViewApi', 'AjaxService', 'cacheStorageService', '$q', '$http',
    function (authService, magViewApi, AjaxService, cacheStorageService, $q, $http) {
      return {
        getFollowUps: function (ssn) {
          const url = `${authService.currentMagViewUrl()}${magViewApi}/followup/loadFollowUps`;
          return AjaxService.post(url, {ssn});
        },
        loadFollowUpsOnDue: function(ssn){
          const url = `${authService.currentMagViewUrl()}${magViewApi}/followup/loadFollowUpsOnDue`;
          return AjaxService.post(url, {ssn});
        },
        resolveFollowUp: function (followUp) {
          const url = `${authService.currentMagViewUrl()}${magViewApi}/followup/resolve`;
          return AjaxService.post(url, followUp);
        },
        loadFollowUpFindings: function(followUpId) {
          const url = `${authService.currentMagViewUrl()}${magViewApi}/followup/loadFollowUpFindingsDescription`;
          return AjaxService.post(url, {Id: followUpId});
        },
        reopenFollowUp: function (ssn, followUpId) {
          return AjaxService.post(authService.currentMagViewUrl() + magViewApi + '/followup/reopen', {Ssn: ssn, Id: followUpId});
        },
        createFollowUps: function (data) {
          return AjaxService.post(authService.currentMagViewUrl() + magViewApi + '/followup', data);
        },
        updateFollowUps: function (id, data) {
          return AjaxService.put(authService.currentMagViewUrl() + magViewApi + '/followup/' + id, data);
        },
        deleteFollowUp: function (id) {
          return AjaxService.delete(authService.currentMagViewUrl() + magViewApi + '/followup/' + id);
        },
        getFollowUp: function (id) {
          const url = `${authService.currentMagViewUrl()}${magViewApi}/followup/${id}`;
          return AjaxService.get(url);
        },
        getRecommendations: function () {
          let defer = $q.defer();

          let recommendationCacheKey = "FOLLOWUPS_RECOMMENDATIONS";

          let recommendations = cacheStorageService.retrieve(recommendationCacheKey);

          if (recommendations && recommendations.length) {
            defer.resolve(recommendations);
            return defer.promise;
          }

          AjaxService.get(authService.currentMagViewUrl() + magViewApi + '/recommendation')
            .then(function (response) {
              cacheStorageService.store(recommendationCacheKey, response);
              defer.resolve(response);
            }, function (error) {
              defer.reject(error);
            });

          return defer.promise;
        },
        getResolutions: function(){
          const url = `${authService.currentMagViewUrl()}${magViewApi}/followup/resolutions`;
          return AjaxService.get(url);
        },
        getAssessments: function () {
          let defer = $q.defer();

          let assessmentCacheKey = "FOLLOWUPS_ASSESSMENTS";

          let assessments = cacheStorageService.retrieve(assessmentCacheKey);

          if (assessments && assessments.length) {
            defer.resolve(assessments);
            return defer.promise;
          }

          AjaxService.get(authService.currentMagViewUrl() + magViewApi + '/followup/assessments')
            .then(function (response) {
              cacheStorageService.store(assessmentCacheKey, response);
              defer.resolve(response);
            }, function (error) {
              throw error;
            });

          return defer.promise;
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/domains/followUps.js